import * as firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'


const instance = firebase.initializeApp({
  apiKey: 'AIzaSyDw3rcToATy01eBjW7-Ew7Dn8wKYlNAWPk',
  authDomain: 'constructionapp-c3a95.firebaseapp.com',
  databaseURL: 'https://constructionapp-c3a95.firebaseio.com',
  projectId: 'constructionapp-c3a95',
  storageBucket: 'constructionapp-c3a95.appspot.com',
  messagingSenderId: '743918861838'
})

export const firebaseMain = firebase

export default instance



// WEBPACK FOOTER //
// ./src/firebase_client.ts